import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {
  @Output() clickedOutside = new EventEmitter<void>(); // tslint:disable-line:no-output-on-prefix

  @HostListener('document:click', ['$event'])
  public onClick(event) {
    const target = event.target;
    if (!this._elementRef.nativeElement.contains(target)) {
      this.clickedOutside.emit();
    }
  }

  constructor(private _elementRef: ElementRef) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/click-outside.directive.ts